<template>
  <div class="contents">
    <GuestTopBar layout="split" />

    <AppNavHeader
      variant="landing"
      :reset-notifications="resetNotifications"
      @open-mobile-menu="openMobileMenu"
    >
      <template #preActions>
        <NavigationPreActions
          :show-cart="showCart"
          :notifications="notifications"
        />
      </template>

      <template #bottom>
        <MobileNavDrawer
          :open="mobileMenuOpen"
          @close="closeMobileMenu"
        />

        <DraftOrdersDrawer
          :is-open="cartStore.isDraftOrdersOpen"
          @close="cartStore.closeDraftOrdersCart"
        />
      </template>
    </AppNavHeader>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import GuestTopBar from '~/components/GuestTopBar.vue'
import AppNavHeader from '~/components/AppNavHeader.vue'
import MobileNavDrawer from '~/components/MobileNavDrawer.vue'
import DraftOrdersDrawer from '~/components/DraftOrdersDrawer.vue'
import NavigationPreActions from '~/components/NavigationPreActions.vue'
import { useCartStore } from '~/stores/useCartStore'
import { useShowAddToCart } from '~/composables/useShowAddToCart'
import { useNotificationsNav } from '~/composables/useNotificationsNav'

const cartStore = useCartStore()

const { showAddToCart: showCart } = useShowAddToCart()

const notifications = useNotificationsNav({ enabled: showCart })
const { resetNotifications } = notifications

const mobileMenuOpen = ref(false)

const openMobileMenu = () => {
  mobileMenuOpen.value = true
}

const closeMobileMenu = () => {
  mobileMenuOpen.value = false
}
</script>
